<template>
  <zh-table-page v-bind="{ title: '重点物料报废及入库' }">
    <template #header-btn>
      <el-button type="primary" icon="Plus" @click="handleAdjust(null, 1)"
        >新增</el-button
      >
    </template>
    <template #search>
      <el-form :model="searchData" ref="searchRef">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="表具编号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="报废日期：">
              <el-date-picker
                v-model="searchData.scrapDate"
                type="daterange"
                placeholder="请选择"
                style="width: 100%"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="报废入库日期：">
              <el-date-picker
                v-model="searchData.scrapInDate"
                type="daterange"
                placeholder="请选择"
                style="width: 100%"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <el-row>
        <el-button type="primary" icon="Search" @click="getList()"
          >查询</el-button
        >
        <el-button icon="Refresh" @click="handleReset()">重置</el-button>
      </el-row>

      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
      >
        <!-- <el-table-column type="selection" width="55" /> -->
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="120"
            :width="item.width || ''"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="item.prop === 'scrapTime'">{{
                row.scrapTime ? row.scrapTime.split(" ")[0] : ""
              }}</span>
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="180">
          <template #default="{ row }">
            <el-button
              v-if="!row.scrapInTime"
              type="primary"
              link
              @click="handleAdjust(row, 3)"
              >报废入库</el-button
            >
            <el-button type="primary" link @click="handleAdjust(row, 2)"
              >编辑</el-button
            >
            <el-button type="danger" link @click="handleDelete(row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <Adjust ref="adjustRef" @update="getList" />
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import useStashTable from "./hooks/useStashTable";
import Adjust from "./adjust.vue";

const {
  searchRef,
  searchData,
  tableLoading,
  columns,
  tableData,
  pages,
  adjustRef,
  getList,
  handleSizeChange,
  handleCurrentChange,
  handleReset,
  handleAdjust,
  handleDelete,
} = useStashTable();

onMounted(() => {
  getList();
});
</script>

<style scoped></style>
